var ProductCompare = (function() {
  function getCompareList() {
    try {
      return JSON.parse(localStorage.getItem('product_compare_list') || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveCompareList(list) {
    localStorage.setItem('product_compare_list', JSON.stringify(list));
  }

  function getCachedData() {
    try {
      return JSON.parse(localStorage.getItem('product_compare_cached_data') || '{}');
    } catch (e) {
      return {};
    }
  }

  function saveCachedData(data) {
    localStorage.setItem('product_compare_cached_data', JSON.stringify(data));
  }

  function syncCheckboxes() {
    var list = getCompareList();
    var handles = list.map(function(p) { return p.handle; });
    document.querySelectorAll('.card-compare-checkbox').forEach(function(cb) {
      cb.checked = handles.indexOf(cb.dataset.productHandle) !== -1;
    });
  }

  function addProduct(checkbox) {
    var list = getCompareList();
    var handle = checkbox.dataset.productHandle;
    if (list.some(function(p) { return p.handle === handle; })) return;
    list.push({
      id: checkbox.dataset.productId,
      handle: handle,
      title: checkbox.dataset.productTitle,
      price: checkbox.dataset.productPrice,
      image: checkbox.dataset.productImage,
      url: checkbox.dataset.productUrl
    });
    saveCompareList(list);
    syncCheckboxes();
    document.dispatchEvent(new CustomEvent('product-compare-update'));
  }

  function removeProduct(handle) {
    var list = getCompareList();
    list = list.filter(function(p) { return p.handle !== handle; });
    saveCompareList(list);
    syncCheckboxes();
    document.dispatchEvent(new CustomEvent('product-compare-update'));
  }

  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('card-compare-checkbox')) {
      if (e.target.checked) {
        addProduct(e.target);
      } else {
        removeProduct(e.target.dataset.productHandle);
      }
    }
  });

  function ProductCompare(options) {
    this.theadId = options.theadId;
    this.tbodyId = options.tbodyId;
    this.emptyId = options.emptyId;
    this.tableId = options.tableId;
    this.maxProducts = options.maxProducts || 4;
    this.showImages = options.showImages !== false;
    this.showPrice = options.showPrice !== false;
    this.showVendor = options.showVendor === true;
    this.showDescription = options.showDescription !== false;
    this.showType = options.showType !== false;
    this.removeText = options.removeText || 'Remove';
    this.viewText = options.viewText || 'View Details';

    this.productsPerPage = 3;
    this.currentPage = 0;

    this.thead = document.getElementById(this.theadId);
    this.tbody = document.getElementById(this.tbodyId);
    this.emptyEl = document.getElementById(this.emptyId);
    this.tableEl = document.getElementById(this.tableId);
    this.paginationEl = null;

    if (this.thead) this.renderTable();
    this.bindTableEvents();

    var self = this;
    document.addEventListener('product-compare-update', function() {
      if (self.thead) self.renderTable();
    });
  }

  ProductCompare.prototype.renderTable = function() {
    var list = getCompareList();

    if (list.length === 0) {
      if (this.emptyEl) this.emptyEl.style.display = '';
      if (this.tableEl) this.tableEl.style.display = 'none';
      this.removePagination();
      return;
    }

    if (this.emptyEl) this.emptyEl.style.display = 'none';
    if (this.tableEl) this.tableEl.style.display = '';

    var totalPages = Math.ceil(list.length / this.productsPerPage);
    if (this.currentPage >= totalPages) this.currentPage = totalPages - 1;
    if (this.currentPage < 0) this.currentPage = 0;

    var start = this.currentPage * this.productsPerPage;
    var end = Math.min(start + this.productsPerPage, list.length);
    var pageItems = list.slice(start, end);

    this.renderHeader(pageItems);
    this.renderBody(pageItems);
    this.renderPagination(list.length, totalPages);
  };

  ProductCompare.prototype.renderHeader = function(list) {
    var html = '<tr><th class="pc-label-col"></th>';
    for (var i = 0; i < list.length; i++) {
      var product = list[i];
      html += '<th>';
      if (this.showImages && product.image) {
        html += '<img src="' + product.image + '" alt="' + product.title + '" class="pc-product-image" loading="lazy">';
      }
      html += '<a href="' + product.url + '" class="pc-product-title">' + product.title + '</a>';
      html += '<button class="pc-title-toggle" type="button"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 5L6 8L9 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      if (this.showPrice && product.price) {
        html += '<div class="pc-product-price">' + product.price + '</div>';
      }
      html += '<div class="pc-btn-group">';
      html += '<button class="pc-remove-btn" data-handle="' + product.handle + '">' + this.removeText + '</button>';
      html += '<a href="' + product.url + '" class="pc-view-btn">' + this.viewText + '</a>';
      html += '</div>';
      html += '</th>';
    }
    html += '</tr>';
    this.thead.innerHTML = html;
  };

  ProductCompare.prototype.renderBody = function(list) {
    var rows = [];
    if (this.showVendor) rows.push({ label: 'Vendor', key: 'vendor' });
    if (this.showType) rows.push({ label: 'Type', key: 'type' });
    if (this.showDescription) rows.push({ label: 'Description', key: 'description' });

    var cached = getCachedData();
    var needsFetch = [];

    var html = '';
    for (var r = 0; r < rows.length; r++) {
      html += '<tr>';
      html += '<td class="pc-label-col">' + rows[r].label + '</td>';
      for (var p = 0; p < list.length; p++) {
        var handle = list[p].handle;
        var key = rows[r].key;
        var cachedValue = cached[handle] ? cached[handle][key] : null;
        html += '<td class="pc-spec-value" data-handle="' + handle + '" data-key="' + key + '">';
        if (cachedValue !== undefined && cachedValue !== null && cachedValue !== '') {
          html += '<span class="pc-spec-value">' + cachedValue + '</span>';
        } else {
          html += '<span class="pc-loading">Loading...</span>';
          if (needsFetch.indexOf(handle) === -1) needsFetch.push(handle);
        }
        html += '</td>';
      }
      html += '</tr>';
    }

    this.tbody.innerHTML = html;

    for (var i = 0; i < needsFetch.length; i++) {
      this.fetchProduct(needsFetch[i]);
    }
  };

  ProductCompare.prototype.fetchProduct = function(handle) {
    var self = this;
    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var product = data.product;
        var details = {
          vendor: product.vendor,
          type: product.product_type,
          description: product.body_html ? product.body_html.replace(/<[^>]*>/g, '').substring(0, 200) : '-'
        };
        var cached = getCachedData();
        cached[handle] = details;
        saveCachedData(cached);
        self.updateCells(handle, details);
      })
      .catch(function() { self.updateCells(handle, null); });
  };

  ProductCompare.prototype.updateCells = function(handle, data) {
    var cells = this.tbody.querySelectorAll('td[data-handle="' + handle + '"] .pc-loading');
    for (var i = 0; i < cells.length; i++) {
      var td = cells[i].parentNode;
      var key = td.dataset.key;
      var value = '-';
      if (data && data[key] !== undefined && data[key] !== null && data[key] !== '') {
        value = data[key];
      }
      td.innerHTML = '<span class="pc-spec-value">' + value + '</span>';
    }
  };

  ProductCompare.prototype.renderPagination = function(totalItems, totalPages) {
    this.removePagination();

    if (totalPages <= 1) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'pc-pagination';

    var info = document.createElement('span');
    info.className = 'pc-pagination-info';
    info.textContent = 'Page ' + (this.currentPage + 1) + ' of ' + totalPages;

    var prevBtn = document.createElement('button');
    prevBtn.className = 'pc-page-btn pc-page-prev';
    prevBtn.textContent = '‹ Prev';
    if (this.currentPage === 0) prevBtn.disabled = true;
    var self = this;
    prevBtn.addEventListener('click', function() {
      if (self.currentPage > 0) {
        self.currentPage--;
        self.renderTable();
      }
    });

    var nextBtn = document.createElement('button');
    nextBtn.className = 'pc-page-btn pc-page-next';
    nextBtn.textContent = 'Next ›';
    if (this.currentPage >= totalPages - 1) nextBtn.disabled = true;
    nextBtn.addEventListener('click', function() {
      if (self.currentPage < totalPages - 1) {
        self.currentPage++;
        self.renderTable();
      }
    });

    var pageContainer = document.createElement('div');
    pageContainer.className = 'pc-page-numbers';
    for (var i = 0; i < totalPages; i++) {
      var pageBtn = document.createElement('button');
      pageBtn.className = 'pc-page-num';
      if (i === this.currentPage) pageBtn.classList.add('active');
      pageBtn.textContent = i + 1;
      pageBtn.dataset.page = i;
      (function(page) {
        pageBtn.addEventListener('click', function() {
          self.currentPage = page;
          self.renderTable();
        });
      })(i);
      pageContainer.appendChild(pageBtn);
    }

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(pageContainer);
    wrapper.appendChild(nextBtn);
    wrapper.appendChild(info);

    this.tableEl.parentNode.insertBefore(wrapper, this.tableEl.nextSibling);
    this.paginationEl = wrapper;
  };

  ProductCompare.prototype.removePagination = function() {
    if (this.paginationEl) {
      this.paginationEl.parentNode.removeChild(this.paginationEl);
      this.paginationEl = null;
    }
  };

  ProductCompare.prototype.bindTableEvents = function() {
    var self = this;
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('pc-remove-btn')) {
        removeProduct(e.target.dataset.handle);
        self.renderTable();
      }
    });
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('pc-clear-all')) {
        saveCompareList([]);
        saveCachedData({});
        syncCheckboxes();
        self.renderTable();
      }
    });
    document.addEventListener('click', function(e) {
      if (e.target.closest('.pc-title-toggle')) {
        var btn = e.target.closest('.pc-title-toggle');
        var title = btn.previousElementSibling;
        if (title && title.classList.contains('pc-product-title')) {
          title.classList.toggle('pc-title-expanded');
          btn.classList.toggle('pc-title-toggle--expanded');
        }
      }
    });
  };

  return ProductCompare;
})();